import React, {useState, useEffect, useCallback} from 'react';
import {onlineProcessesService} from "../../services";
import QuadralBigNumber from '@quadral/quadral-component-common/dist/components/bigNumber'
import QuadralContainer from '@quadral/quadral-component-common/dist/components/container'
import QuadralList from '@quadral/quadral-component-common/dist/components/list';
import QuadralTypography from '@quadral/quadral-component-common/dist/components/typography';

const IncomeAndExpenses = ({participationId, participation, references, ...props}) => {
    const [rowsRFR, setRowsRFR] = useState([])
    const [rowsCharges, setRowsCharges] = useState([])

    const columnsRFR = [
        {
            id: "name",
            label: "Personne",
            sortable: true,
            typography: "tableBodyWide"
        },
        {
            id: "type",
            label: "Type",
            sortable: true,
        },
        {
            id: "value",
            label: "Montant",
            sortable: true,
            typography: "tableBodyWide"
        },
        {
            id: "status",
            label: "Justificatif",
            sortable: true,
        },
        // {
        //     id: "action",
        //     label: "Actions",
        // },
    ];

    const columnsCharges = [
        {
            id: "person",
            label: "Personne",
            sortable: true,
            typography: "tableBodyWide"
        },
        {
            id: "type",
            label: "Type",
            sortable: true,
        },
        {
            id: "nature",
            label: "Nature",
            sortable: true,
        },
        {
            id: "value",
            label: "Montant",
            sortable: true,
            typography: "tableBodyWide"
        },
        {
            id: "status",
            label: "Justificatif",
            sortable: true,
        },
        // {
        //     id: "action",
        //     label: "Actions",
        // },
    ];

    const splitData = useCallback(async (data) => {
        try {
            const personMap = {};

            for (const item of data) {
                if (item?.personId && !personMap[item.personId]) {
                    try {
                        const personRecord = await onlineProcessesService.getPersonRecordById(
                            participationId,
                            item.personId
                        );

                        personMap[item.personId] = `${personRecord?.firstname} ${personRecord?.lastname}`;
                    } catch (error) {
                        console.error(`Erreur lors de la récupération de la personne ${item.personId}:`, error);
                        personMap[item.personId] = item?.name || '-';
                    }
                }
            }

            const getTypeLabel = (typeCode) => {
                const typeRef = references?.INCOME_AND_EXPENSE_TYPE?.find(
                    ref => ref.code === typeCode
                );
                return typeRef?.label || typeCode;
            };

            const rfrData = data
                .filter(item => item?.type === 'RFR')
                .map(item => ({
                    ...item,
                    value: `${item?.taxAmount || item?.amount} €` || 'Non renseigné',
                    name: (personMap[item?.personId] || item?.name),
                    type: getTypeLabel(item?.type) || 'Non renseigné',
                    status: item?.status || 'Non justifié'
                }));

            const chargesData = data
                .filter(item => item?.type === 'prestations_sociales' || item?.type === 'revenu')
                .map(item => ({
                    ...item,
                    value: `${item?.amount} €` || 'Non renseigné',
                    person: personMap[item?.personId] || item?.name,
                    type: getTypeLabel(item?.type) || 'Non renseigné',
                    nature: item?.nature || 'Prestation',
                    status: item?.status || 'Non justifié'
                }));

            setRowsRFR(rfrData);
            setRowsCharges(chargesData);
        } catch (error) {
            console.error('Erreur lors du traitement des données:', error);
        }
    }, [participationId, references]);

    useEffect(()=> {
        if(props.personIds && props.personIds.length > 0 && participation){
            const promises = props.personIds.map(personId => 
                onlineProcessesService.getIncomeAndCharges(participationId,personId)
            )
            Promise.all(promises)
            .then(dataReceived => {
                const mergedData = dataReceived.flat();
                splitData(mergedData)
            })
            .catch(err => {
                    console.error(err);
            });
        }
    }, [props.personIds, participation, participationId, splitData])

    return(<>
        <QuadralContainer orientation='column' sx={{gap: '2rem'}}>
            <QuadralContainer orientation='row' sx={{gap: '2rem'}}>
                <QuadralBigNumber
                    title='Total Revenu(s) Mensuel(s)'
                    value='ADD_VALUE_HERE'
                />
                <QuadralBigNumber
                    title='Total Prestations'
                    value='ADD_VALUE_HERE'
                />
                <QuadralBigNumber
                    title='Revenu Total Foyer'
                    value={
                        participation?.totalRevenue != null
                        ? `${participation.totalRevenue.toLocaleString('fr-FR')} €`
                        : ''
                    }
                    color='primary'
                />
                <QuadralBigNumber
                    title='RFR Total'
                    value={
                        participation?.totalRFR != null
                        ? `${participation.totalRFR.toLocaleString('fr-FR')} €`
                        : ''
                    }
                    color='primary'
                />
            </QuadralContainer>
            <QuadralContainer>
                <QuadralList
                    title='Revenu fiscal de référence'
                    columns={columnsRFR}
                    rows={rowsRFR}
                    sortable
                />
                {rowsRFR.length === 0 && (
                    <QuadralContainer sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '2rem'}}>
                        <QuadralTypography variant='label'>
                            Non renseigné
                        </QuadralTypography>
                    </QuadralContainer>
                )}
            </QuadralContainer>
            <QuadralContainer>
                <QuadralList
                    title='Revenus et prestations du foyer'
                    columns={columnsCharges}
                    rows={rowsCharges}
                    sortable
                />
                {rowsCharges.length === 0 && (
                    <QuadralContainer sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '2rem'}}>
                        <QuadralTypography variant='label'>
                            Non renseigné
                        </QuadralTypography>
                    </QuadralContainer>
                )}
            </QuadralContainer>
        </QuadralContainer>
    </>)
}

export default IncomeAndExpenses;